import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { supabase } from "@vendor/supabase";

export const Route = createFileRoute("/auth/callback")({
  component: CallbackPage,
});

function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    if (!code) {
      void navigate({ to: "/login" });
      return;
    }
    supabase.auth.exchangeCodeForSession(code).then(({ error }) => {
      void navigate({ to: error ? "/login" : "/" });
    });
  }, [navigate]);

  return null;
}
